import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/**
 * Section heading row with optional "Ver todo" link.
 *
 * @example
 * <om-section-header title="Últimos Recuerdos" linkLabel="Ver todo" (linkClicked)="onViewAll()" />
 */
@Component({
  selector: 'om-section-header',
  imports: [],
  templateUrl: './section-header.html',
  styleUrl: './section-header.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHeader {
  title = input.required<string>();
  linkLabel = input<string>('');
  linkClicked = output<void>();
}
